import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { S3Upload } from 'src/app/common/utils/S3Upload';
import { GUID } from 'src/app/common/utils/GuidUtils';
import { Advertiser, CampaignsCampaignAdminApiClient, ProductReward } from 'src/app/api/api-campaigns.service.generated';
import { MessageDialogModel } from 'src/app/common/message-dialog/message-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { LoadingOverlayComponent, PhotoComponent, ButtonComponent } from 'wecheer-common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { lastValueFrom } from 'rxjs';

export class CreateRewardOptions {
  advertiser: Advertiser;
}

@Component({
  selector: 'app-advertiser-campaign-reward-edit',
  templateUrl: './advertiser-campaign-reward-edit.component.html',
  styleUrls: ['./advertiser-campaign-reward-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    PhotoComponent,
    LoadingOverlayComponent,
    ReactiveFormsModule,
    ButtonComponent
]
})
export class AdvertiserCampaignRewardEditComponent implements OnInit {
  private dialog = inject(MatDialog);
  private dialogRef = inject<MatDialogRef<AdvertiserCampaignRewardEditComponent, ProductReward | undefined>>(MatDialogRef);
  private campaignsApi = inject(CampaignsCampaignAdminApiClient);
  private snackBar = inject(MatSnackBar);
  data = inject<CreateRewardOptions>(MAT_DIALOG_DATA);


  static async showDialog(dialog: MatDialog, options: CreateRewardOptions): Promise<ProductReward> {
    const config = {
      width: '600px',
      data: options
    };
    return await lastValueFrom(dialog.open(AdvertiserCampaignRewardEditComponent, config).afterClosed());
  }

  form: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    description: new FormControl('', [Validators.required, Validators.maxLength(1000)])
  });

  isLoading = false;
  isAdding = true;
  photoUrl: string;
  uploadKeyReward: string;
  ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png'];

  advertiser: Advertiser;

  constructor() {
    const data = this.data;


    this.advertiser = data.advertiser;
  }

  async ngOnInit() {
  }

  async onSubmit() {

    if (!this.form.valid || !this.photoUrl)
      return;

    const f = this.form.value;

    if (f.title.toString().trim() === '') {
      this.snackBar.open(`Invalid product title`, null, { duration: 3000 });
      return;
    }

    this.isLoading = true;
    try {

      const productReward = new ProductReward({
        rewardTitle: f.title,
        rewardDescription: f.description,
        rewardPhotoUrl: this.photoUrl,
        rewardThumbUrl: this.photoUrl,
        uploadKey: this.uploadKeyReward
      });

      this.dialogRef.close(productReward);
    } catch (err: any) {
      if (err.status === 400 && err.response)
        new MessageDialogModel(err.response).show(this.dialog);

    } finally {
      this.isLoading = false;
    }
  }

  async onAvatarImageSelected(event: any) {
    try {
      const file = event.target.files[0];
      if (!file || !this.isValidFile(file)) {
        this.snackBar.open('Invalid image file', 'Dismiss', { duration: 2000 });
        return;
      }

      this.uploadKeyReward = GUID.newGuid().replace(/-/g, '') + '.' + file.name.split('.').pop(); // preserve extension on s3 key
      const uploadUrl = await lastValueFrom(this.campaignsApi.getUploadUrl(this.uploadKeyReward));
      const uploadSuccess = await lastValueFrom(S3Upload.upload(uploadUrl, file)); // upload to s3
      if (uploadSuccess) {
        const parts = uploadUrl.split('?');
        const photoUrl = parts[0];
        this.photoUrl = photoUrl.replace('s3.ap-southeast-1.amazonaws.com/', ''); // trim s3 part to get photo using cloudfront
      }
    } catch (err) {
      console.error('upload failed', err);
    }
  }

  isValidFile(file: File): boolean {
    return file.name && this.ALLOWED_EXTENSIONS.filter(e => file.name.trim().toLowerCase().endsWith(e)).length > 0;
  }

  onClose(): void {
    this.dialogRef.close(undefined);
  }

}
